import { useDataChange, useDataValue } from 'Simple/Data.js'
import { useEffect, useCallback } from 'react'
import View from './view.js'
import query from './query-get-document-templates.graphql.js'
import { useClient } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'

export default function Logic(props) {
  let client = useClient()
  let change = useDataChange({
    context: 'modal',
    viewPath: props.viewPath,
  })
  let current_location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })
  let [, notify] = useNotifications()

  let resolveLetters = useCallback(
    async letters => {
      let templates = null
      let resolved_letters = []

      async function findTemplate(name) {
        if (!templates) {
          let { data, error } = await client
            .query(query, { org_id: current_location_id })
            .toPromise()
          if (error) {
            throw error
          }

          templates = data?.documents_get_document_templates_for_org || []
        }

        return templates.find(t => t.name === name)
      }

      for (let letter of letters) {
        if (letter.document_node_id) {
          resolved_letters.push(letter)
        } else if (letter.document_template_name) {
          let { document_template_name, ...rest_letter } = letter

          let template = await findTemplate(document_template_name)

          if (template) {
            resolved_letters.push({
              document_template_id: template.id,
              ...rest_letter,
            })
          } else {
            notify(
              notifyError(
                `Document template "${document_template_name}" not found.`
              )
            )
          }
        }
      }

      return resolved_letters
    },
    [client, current_location_id]
  ) // eslint-disable-line

  useEffect(() => {
    if (props.letters?.length) {
      ;(async () => {
        let resolved_letters = await resolveLetters(props.letters)

        if (resolved_letters.length) {
          change(next => {
            next.letters.push(...resolved_letters)
          })
        }
      })()
    }
  }, [props.letters, resolveLetters]) // eslint-disable-line

  useEffect(() => {
    change(next => {
      next.letter_params.patient_id = props.patientId
      next.letter_params.appointment_id = props.appointmentId
      next.letter_params.booking_id = props.bookingId
      next.letter_params.diagnosis_id = props.diagnosisId
      next.letter_params.tooth_chart_snapshot_id = props.toothChartSnapshotId
      next.letter_params.tooth_marking_ids = props.toothMarkingIds
    })
  }, [
    props.appointmentId,
    props.bookingId,
    props.patientId,
    props.diagnosisId,
    props.toothChartSnapshotId,
    props.toothMarkingIds,
  ]) // eslint-disable-line

  return <View {...props} />
}
